import normalizeStyles from './normalize'
import globalStyles from './global'

// Normalize styles.
export const NormalizeComponent = normalizeStyles()
// Global styles
export const GlobalStylesComponent = globalStyles()
